import { defineFetch } from 'resift';
import * as Types from 'pages/Pages/typings';

const makeCreateEntityType = defineFetch({
  displayName: 'Create Entity Type',
  make: () => ({
    request: ({
      name,
      newPersonFieldType,
      convertPersonField,
      parentFieldId,
    }: Types.NewEntityType) => ({ http }: any) =>
      http({
        method: 'POST',
        route: '/entity-types',
        data: {
          name,
          isActive: false,
          newPersonFieldType,
          convertPersonField,
          parentFieldId,
        },
      }),
  }),
});

const createEntityType = makeCreateEntityType();

export default createEntityType;
